/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type CashTransferRequestSubtype = "CASH_POSITION" | "DIRECT_DEBIT" | "ONBOARDING" | "PHASED" | "POSITION_CASH" | "REBALANCE" | "RINGFENCE_LIQUIDATION" | "TOPUP" | "UNCATEGORIZED" | "WITHDRAWAL" | "%future added value";
export type CashTransferStatus = "APR" | "CAN" | "PEN" | "REC" | "VER" | "%future added value";
export type ContraParty = "BK" | "CL" | "CS" | "IB" | "PP" | "%future added value";
export type Currency = "AUD" | "BGN" | "CAD" | "CHF" | "CLP" | "CNH" | "CNY" | "CZK" | "DKK" | "EUR" | "GBP" | "HKD" | "HUF" | "ISK" | "JPY" | "MXN" | "NOK" | "NZD" | "PLN" | "ROL" | "RON" | "RUB" | "SEK" | "SGD" | "USD" | "ZAR" | "%future added value";
export type Custodian = "BK" | "CS" | "IB" | "VI" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type CashTransferRequestDetailsFormBase_viewer$ref: FragmentReference;
declare export opaque type CashTransferRequestDetailsFormBase_viewer$fragmentType: CashTransferRequestDetailsFormBase_viewer$ref;
export type CashTransferRequestDetailsFormBase_viewer = {|
  +cashTransferRequests: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +createdAt: any,
        +updatedAt: any,
        +subtype: CashTransferRequestSubtype,
        +amount: number,
        +custodian: Custodian,
        +currency: Currency,
        +blocked: boolean,
        +status: ?CashTransferStatus,
        +contraParty: ContraParty,
        +batch: ?{|
          +createdAt: any,
          +id: string,
          +name: string,
          +inverseBatch: ?{|
            +id: string,
            +name: string,
          |},
        |},
        +cashtransferrequestapprovalSet: {|
          +edges: $ReadOnlyArray<?{|
            +node: ?{|
              +approvedAt: any,
              +approvedBy: {|
                +fullName: ?string
              |},
            |}
          |}>
        |},
        +cashTransfer: ?{|
          +id: string,
          +brokerActivity: {|
            +id: string
          |},
        |},
      |}
    |}>
  |},
  +$refType: CashTransferRequestDetailsFormBase_viewer$ref,
|};
export type CashTransferRequestDetailsFormBase_viewer$data = CashTransferRequestDetailsFormBase_viewer;
export type CashTransferRequestDetailsFormBase_viewer$key = {
  +$data?: CashTransferRequestDetailsFormBase_viewer$data,
  +$fragmentRefs: CashTransferRequestDetailsFormBase_viewer$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createdAt",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "CashTransferRequestDetailsFormBase_viewer",
  "type": "Query",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "cashTransferRequestId",
      "type": "ID",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "cashTransferRequests",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "cashTransferRequestId"
        }
      ],
      "concreteType": "CashTransferRequestNodeConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "CashTransferRequestNodeEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "CashTransferRequestNode",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "updatedAt",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "subtype",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "amount",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "custodian",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "currency",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "blocked",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "status",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "contraParty",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "batch",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "CashTransferRequestBatchNode",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v0/*: any*/),
                    (v2/*: any*/),
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "inverseBatch",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "CashTransferRequestBatchNode",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        (v2/*: any*/)
                      ]
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "cashtransferrequestapprovalSet",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "CashTransferRequestApprovalNodeConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "CashTransferRequestApprovalNodeEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "CashTransferRequestApprovalNode",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "approvedAt",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "approvedBy",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "UserNode",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "alias": null,
                                  "name": "fullName",
                                  "args": null,
                                  "storageKey": null
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "cashTransfer",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "CashTransferNode",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "brokerActivity",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "BrokerActivityNode",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/)
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ca2cb9d31e39da3765c2aa4d9618b7ee';
module.exports = node;
